<div class="top-destinations">
  <ng-container
    *ngIf="!loading; else loadingContainer"
    [ngTemplateOutlet]="topDestinationsView"
    [ngTemplateOutletContext]="{ state: states[states.length - 1] }"
  >
  </ng-container>
</div>

<ng-template #topDestinationsView let-state="state">
  <div *ngIf="state.topDestinations?.length > 0" class="d-flex selected-result" data-test="selected-destination">
    <div class="chart">
      <canvas
        #doughnutChart="doughnut-chart"
        appDoughnutChart
        [values]="state.chartData"
        width="128"
        height="128"
      ></canvas>
    </div>
    <div class="d-flex flex-column flex-fill justify-content-center align-items-center details">
      <div class="percentage" data-test="percentage">
        {{ state.topDestinations[state.selectedIndex].percentFromTotal | number: '1.0-0' }}%
      </div>
      <div class="name align-items-start flex-fill" data-test="name">
        {{ state.topDestinations[state.selectedIndex].code }}
      </div>
    </div>
  </div>

  <div
    *ngIf="state.parentDestination"
    class="back-row py-3 d-flex flex-row cursor-pointer"
    (click)="backToParentDestinations()"
    data-test="back-row"
  >
    <div class="index px-3">&nbsp;</div>
    <div class="name align-items-start flex-fill px-3" data-test="name">{{ state.parentDestination.code }}</div>
    <div class="back-link text-center px-3" data-test="back-link">
      <span class="fa-angle-left"></span>
    </div>
  </div>

  <ng-container
    *ngIf="state.topDestinations?.length > 0; else noData"
    [ngTemplateOutlet]="topDestinationsList"
    [ngTemplateOutletContext]="{state}"
  >
  </ng-container>
</ng-template>

<ng-template #topDestinationsList let-state="state">
  <div class="destinations-list" data-test="destinations-list">
    <div
      *ngFor="let topDestination of state.topDestinations; index as i"
      class="top-destination-row py-3 d-flex flex-row"
      [ngClass]="{
        'cursor-pointer': state.destinationType !== DestinationType.HOTEL,
        selected: state.selectedIndex === i
      }"
      (click)="state.destinationType !== DestinationType.HOTEL && expandSubDestinations(i)"
      data-test="destination-row"
    >
      <div class="index px-3" data-test="index">{{ i + 1 }}</div>
      <div class="name align-items-start flex-fill px-3 color-link" data-test="name">{{ topDestination.code }}</div>
      <div class="value align-items-end px-3 text-right" data-test="value">
        {{ topDestination.currency && statisticsType !== StatisticsType.NUMBER_OF_BOOKINGS
            ? (topDestination.value | currency: topDestination.currency:'symbol-narrow':'1.0-0')
            : (topDestination.value | number: '1.0-0')
        }}
      </div>
      <div class="percentage px-3 text-right" data-test="percent-from-total">
        {{ topDestination.percentFromTotal | number: '1.0-0' }}%
      </div>
      <div
        *ngIf="state.destinationType !== DestinationType.HOTEL"
        class="details-link text-center px-3"
        data-test="details-link"
      >
        <span class="fa-angle-right"></span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loadingContainer>
  <div class="d-block py-2 mt-4 loading-container text-center" data-test="loading-indicator">
    <div class="spinner-border text-primary" role="status"></div>
  </div>
</ng-template>

<ng-template #noData>
  <div class="d-flex justify-content-center">
    <figure class="figure mt-4" data-test="kaliuk">
      <svg class="kaliuk kaliuk-middle">
        <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
      </svg>
      <figcaption class="figure-caption">
        <h4 i18n="@@amadeus-direct.avc-dashboard.no-data">No data for the specified period</h4>
      </figcaption>
    </figure>
  </div>
</ng-template>
